import {type P0AlertStatus} from '@/api/p0Alerts';

type BadgeVariant = 'default' | 'destructive' | 'secondary' | 'outline';

const STATUS_BADGE: Record<P0AlertStatus, {label: string; variant: BadgeVariant}> = {
  pending_approval: {label: 'Pending Approval', variant: 'outline'},
  approved: {label: 'Approved', variant: 'secondary'},
  delivered: {label: 'Delivered', variant: 'default'},
  rejected: {label: 'Rejected', variant: 'destructive'}
};

// Status is a plain string server-side, not a real enum - an older/retired status value already
// sitting in the DB (e.g. from a since-reverted feature) must render as *something* rather than
// crashing the whole page.
export function statusBadge(status: P0AlertStatus): {label: string; variant: BadgeVariant} {
  return STATUS_BADGE[status] ?? {label: status, variant: 'outline'};
}
